














































import { Component, Vue } from 'vue-property-decorator';
import '../../assets/css/AccountSetup.scss';
import '../../assets/css/Common.scss';
import '../../assets/css/MainLayout.scss';
import { ProfileRequest } from '@/types/request';
import { MedTransGoConstants } from '../../util/constants';
import { ObjectFactory } from '../../config/objectFactory';
import { CommonUtils } from '@/util/commonUtils';
import { Questionnaire } from '@/types/entity';
import { DateUtils } from '@/util/dateUtils';
// tslint:disable-next-line: no-var-requires
const ProfileFormData = require('../../config/ProfileFormData');
@Component({})
export default class AccountSetup extends Vue {
    private iCacheService = ObjectFactory.getCacheService();
    private sessionInfo = this.iCacheService.getSessionInfo();
    private profileRequest: ProfileRequest = {
        address: {
            fullAddress: '',
        },
        companyName: '',
        email: '',
        fullname: '',
        phone: '',
        companyPhoneNumber: '',
        companyTaxId: '',
        companyWebsite: '',
        hasAdditionalLocation: false,
        title: '',
        transporterId: '',
        locations: [],
        users: [],
        userId: this.sessionInfo.id,
        languageCertificates: [
            {
                certificateId: '',
                name: '',
                languageId: '',
            },
        ],
        roles: [],
        documents: JSON.parse(JSON.stringify(ProfileFormData.documents)),
        questionnaires: this.getQuestionaries(),
        isStepPIValid: false,
        isStepUCValid: false,
        isStepUDValid: false,
        isStepQnValid: false,
        isStepHIValid: false,
        isStepADValid: false,
        updatePartnerProfileRequest: {
            interpreterProfile: {},
            transporterProfile: {},
            homeHealthCareProfile: {},
        },
        sourceAnswer: '',
        sourceDetailsQuestion: '',
        sourceDetailsAnswer: '',
        totalDocumentCount: ProfileFormData.documents.length,
    };

    get isInterpreter() {
        return this.sessionInfo.scopes.includes('interpreter');
    }

    get isTransporter() {
        return this.sessionInfo.scopes.includes('transporter');
    }

    get isHomeHealthCare() {
        return this.sessionInfo.scopes.includes('homeHealthCare');
    }

    private getQuestionaries(): Questionnaire[] {
        const sessionInfo = ObjectFactory.getCacheService().getSessionInfo();
        const questionnaires: Questionnaire[] =  [];
        const transporterQuestionaries = ProfileFormData.questionnaires;
        const homeHealthCareQuestionnaires = ProfileFormData.homeHealthCareQuestionnaires;
        if (sessionInfo.scopes.includes('transporter')) {
            transporterQuestionaries.forEach((element: Questionnaire) => {
                questionnaires.push(element);
            });
        }
        if (sessionInfo.scopes.includes('homeHealthCare')) {
            homeHealthCareQuestionnaires.forEach((element: Questionnaire) => {
                const index = questionnaires.findIndex((questionarie) => {
                    return questionarie.question === element.question;
                });
                if (index < 0) {
                    questionnaires.push(element);
                }
            });
        }
        return questionnaires;
    }
    private async mounted() {
        const iCacheService = ObjectFactory.getCacheService();
        const partnerService = ObjectFactory.getPartnerService();
        const response = await partnerService.getPartnerProfile(this.$store.state.serverUrl);
        if (response.success && response.data) {
            const partnerProfile = response.data;
            let referralSource;
            if (partnerProfile.interpreterProfile) {
                if (partnerProfile.interpreterProfile.address) {
                    this.profileRequest.address = partnerProfile.interpreterProfile.address;
                }
                this.profileRequest.fullname = partnerProfile.interpreterProfile.fullname;
                this.profileRequest.email = partnerProfile.interpreterProfile.email;
                this.profileRequest.phone = partnerProfile.interpreterProfile.phone;
                referralSource = partnerProfile.interpreterProfile.referralSource;
            }
            if (partnerProfile.transporterProfile) {
                const transporterProfile = partnerProfile.transporterProfile;
                referralSource = transporterProfile.referralSource;
                if (transporterProfile.address) {
                    this.profileRequest.address = transporterProfile.address;
                }
                this.profileRequest.fullname = transporterProfile.fullname;
                this.profileRequest.email = transporterProfile.email;
                this.profileRequest.phone = transporterProfile.phone;
                this.profileRequest.companyName = transporterProfile.companyName;
                this.profileRequest.locations = transporterProfile.locations ? transporterProfile.locations : [];
                this.profileRequest.companyPhoneNumber = transporterProfile.companyPhoneNumber;
                this.profileRequest.companyTaxId = transporterProfile.companyTaxId,
                this.profileRequest.companyWebsite = transporterProfile.companyWebsite,
                this.profileRequest.title = transporterProfile.title,
                this.profileRequest.users = transporterProfile.users ? transporterProfile.users : [];
                this.profileRequest.roles = transporterProfile.roles ? transporterProfile.roles : [];
                this.profileRequest.transporterId = transporterProfile.id;
                if (transporterProfile.documents && transporterProfile.documents.length > 0) {
                    transporterProfile.documents.forEach((element) => {
                        const objIndex = this.profileRequest.documents.findIndex(((obj) =>
                            obj.name === element.name));
                        if (objIndex >= 0 && (!element.expirationDate || element.expirationDate >
                            DateUtils.getCurrentUTCTimeInMillis()) && !element.rejected) {
                            this.profileRequest.documents[objIndex].resourceId = element.resourceId;
                            this.profileRequest.documents[objIndex].filename = element.filename;
                        }
                    });
                }
                if (transporterProfile.locations && transporterProfile.locations.length) {
                    this.profileRequest.hasAdditionalLocation = true;
                }
                if (transporterProfile.questionnaires && transporterProfile.questionnaires.length > 0) {
                    transporterProfile.questionnaires.forEach((questionarie) => {
                        const objIndex = this.profileRequest.questionnaires.findIndex(((obj) =>
                            obj.question === questionarie.question));
                        if (objIndex >= 0) {
                            this.profileRequest.questionnaires[objIndex].answer = questionarie.answer;
                            if (questionarie.answer && questionarie.answer === 'true') {
                                this.profileRequest.questionnaires[objIndex].answer = true;
                            } else if (questionarie.answer && questionarie.answer === 'false') {
                                this.profileRequest.questionnaires[objIndex].answer = false;
                            }
                            if (this.profileRequest.questionnaires[objIndex].type === 'select' ||
                                this.profileRequest.questionnaires[objIndex].type === 'tabs') {
                                this.profileRequest.questionnaires[objIndex].answer = questionarie.answer.split(',');
                                if (this.profileRequest.questionnaires[objIndex].type === 'tabs') {
                                    const newQuestionArray = [];
                                    for (let i = 0; i <= objIndex; i++) {
                                        const element = this.profileRequest.questionnaires[i];
                                        newQuestionArray.push(element);
                                    }
                                    const question = this.profileRequest.questionnaires[objIndex];
                                    for (let i = 0; i <= question.answer.length; i++) {
                                        const value = question.answer[i];
                                        if (ProfileFormData.subQuestions[value]) {
                                            ProfileFormData.subQuestions[value].forEach((element: any) => {
                                                newQuestionArray.push(element);
                                            });
                                        }
                                    }
                                    for (let i = objIndex + 1 ; i < this.profileRequest.questionnaires.length; i++) {
                                        const element = this.profileRequest.questionnaires[i];
                                        newQuestionArray.push(element);
                                    }
                                    this.profileRequest.questionnaires = newQuestionArray;
                                }
                            }
                            if (this.profileRequest.questionnaires[objIndex].childQuestions) {
                                const childQuestions = this.profileRequest.questionnaires[objIndex].childQuestions;
                                if (this.profileRequest.questionnaires[objIndex].answer === 'true' && childQuestions) {
                                    const newQuestionArray = [];
                                    for (let i = 0; i <= objIndex; i++) {
                                        const element = this.profileRequest.questionnaires[i];
                                        newQuestionArray.push(element);
                                    }
                                    childQuestions.forEach((element) => {
                                        newQuestionArray.push(element);
                                    });
                                    for (let i = objIndex + 1 ; i < this.profileRequest.questionnaires.length; i++) {
                                        const element = this.profileRequest.questionnaires[i];
                                        newQuestionArray.push(element);
                                    }
                                    this.profileRequest.questionnaires = newQuestionArray;
                                }
                            }
                        }
                    });
                }
            }
            if (partnerProfile.homeHealthCareProfile) {
                const homeHealthCareProfile = partnerProfile.homeHealthCareProfile;
                referralSource = homeHealthCareProfile.referralSource;
                if (homeHealthCareProfile.address) {
                    this.profileRequest.address = homeHealthCareProfile.address;
                }
                this.profileRequest.fullname = homeHealthCareProfile.fullname;
                this.profileRequest.email = homeHealthCareProfile.email;
                this.profileRequest.phone = homeHealthCareProfile.phone;
                this.profileRequest.companyName = homeHealthCareProfile.companyName;
                if (this.profileRequest.roles && this.profileRequest.roles.length && homeHealthCareProfile.roles) {
                    homeHealthCareProfile.roles.forEach((element) => {
                        if (this.profileRequest.roles) {
                            this.profileRequest.roles.push(element);
                        }
                    });
                } else {
                    this.profileRequest.roles = homeHealthCareProfile.roles ? homeHealthCareProfile.roles : [];
                }
                if (homeHealthCareProfile.documents && homeHealthCareProfile.documents.length > 0) {
                    homeHealthCareProfile.documents.forEach((element) => {
                        const objIndex = this.profileRequest.documents.findIndex(((obj) =>
                            obj.name === element.name));
                        if (objIndex >= 0) {
                            this.profileRequest.documents[objIndex].resourceId = element.resourceId;
                            this.profileRequest.documents[objIndex].filename = element.filename;
                        }
                    });
                }
                if (homeHealthCareProfile.questionnaires && homeHealthCareProfile.questionnaires.length > 0) {
                    homeHealthCareProfile.questionnaires.forEach((questionarie) => {
                        const objIndex = this.profileRequest.questionnaires.findIndex(((obj) =>
                            obj.question === questionarie.question));
                        if (objIndex >= 0) {
                            this.profileRequest.questionnaires[objIndex].answer = questionarie.answer;
                        }
                    });
                }
            }
            if (partnerProfile.interpreterProfile &&
                !CommonUtils.isEmpty(partnerProfile.interpreterProfile.languages)) {
                this.profileRequest.languageCertificates = [];
                partnerProfile.interpreterProfile.languages.forEach((element) => {
                    element.certificates.forEach((certificate) => {
                        this.profileRequest.languageCertificates.push({
                            certificateId: certificate.certificateId,
                            name: certificate.name,
                            languageId: element.languageId,
                        });
                    });
                });
            }
            if (referralSource) {
                const splits = referralSource.split('-');
                this.profileRequest.sourceAnswer = splits[0];
                this.profileRequest.sourceDetailsQuestion = this.getSubQuestion(this.profileRequest.sourceAnswer);
                if (splits.length > 1) {
                    this.profileRequest.sourceDetailsAnswer = splits.slice(1).join('-');
                }
            }
        }

        this.$on(MedTransGoConstants.EVENT_SAVE_PROFILE_REQUEST, () => {
            iCacheService.saveValue(
                MedTransGoConstants.FIELD_PROFILE,
                this.profileRequest,
            );
        });
    }
    private logout() {
        CommonUtils.logout(this.$store.state);
    }
    private getSubQuestion(sourceAnswer: string): string {
        switch (sourceAnswer) {
            case 'Search Engine/Social Media':
                return 'Which Platform?';
            case 'Referral/MTG Rep':
                return 'Name, Company?';
            case 'Blog or Article':
                return 'Which source?';
            case 'Advertisement':
                return 'Which site or platform?';
            case 'In-Person/Virtual Event':
                return 'Which event?';
            case 'Other':
                return 'Other';
        }
        return '';
    }
}
